import React, { useState } from 'react';
import Skeleton from './Skeleton';

const ImageWithLoader = ({ src, alt, style, className, onClick, onMouseEnter, onMouseLeave, ...props }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div style={{ position: 'relative', overflow: 'hidden', ...style }} className={className} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {!loaded && (
                <Skeleton
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 1
                    }}
                />
            )}
            <img
                {...props}
                src={src}
                alt={alt}
                onLoad={() => setLoaded(true)}
                style={{
                    ...style,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    position: 'relative', // Ensure image is positioned relative to its container logic if needed
                    zIndex: 2, // helper zIndex
                    top: 0,
                    left: 0
                }}
            />
        </div>
    );
};

export default ImageWithLoader;
